var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreakfast3X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon / breakfast-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-breakfast-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(5.000000, 3.000000)",
    stroke: "#63666B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.87323077,0.167138462 C8.30748718,0.569189744 7.46030769,1.66990769 8.30051282,2.9601641 C8.64471795,3.48980513 9.08082051,3.75647179 9.464,3.99195897 C10.0929231,4.37677949 10.5466667,4.65534359 10.5466667,5.97801026",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.90888205,0.167138462 C5.34313846,0.569189744 4.49554872,1.66990769 5.33575385,2.9601641 C5.67995897,3.48980513 6.11606154,3.75647179 6.49924103,3.99195897 C7.1281641,4.37677949 7.58231795,4.65534359 7.58231795,5.97801026",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.94412308,0.167138462 C2.37837949,0.569189744 1.53078974,1.66990769 2.37099487,2.9601641 C2.7152,3.48980513 3.15130256,3.75647179 3.53448205,3.99195897 C4.16340513,4.37677949 4.61755897,4.65534359 4.61755897,5.97801026",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.844759,13.2170256 C12.9674256,13.2297436 13.4334769,13.2375385 13.5635282,13.2375385 C14.0373744,13.2375385 14.5522462,13.1403077 15.0244513,12.8445128 C15.9130667,12.2894359 15.9803487,11.2272821 15.7674256,10.4859487 C15.6242462,9.98666667 15.3058872,9.45292308 14.8422974,9.45292308 L14.192041,9.45292308 L13.5003487,9.45292308",
    id: "Stroke-10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7646359,8.1905641 L4.09325128,8.1905641 L0.204841026,8.1905641 C0.204841026,8.1905641 0.204841026,16.5245128 4.6926359,16.5245128 L5.66043077,16.5245128 L8.19745641,16.5245128 L9.16525128,16.5245128 C13.6526359,16.5245128 13.6526359,8.1905641 13.6526359,8.1905641 L9.7646359,8.1905641 Z",
    id: "Stroke-12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast3X);
export default __webpack_public_path__ + "static/media/breakfast@3x.116fbfe6ab81867110d581671726151b.svg";
export { ForwardRef as ReactComponent };